/* Feminine Countdown — lightweight web component
 * Reads target year/month/day/hour/minute/second + timezone offset
 * and updates the displayed digits with a calming flip animation.
 */
(function () {
  if (customElements.get("feminine-countdown")) return;

  const pad = (n) => (n < 10 ? "0" + n : "" + n);

  class FeminineCountdown extends HTMLElement {
    constructor() {
      super();
      this._tick = this._tick.bind(this);
      this._interval = null;
      this._target = 0;
      this._loadingTimeout = null;
    }

    connectedCallback() {
      this._target = this._computeTarget();

      this._units = {
        days: this.querySelector('[data-fc-unit="days"] [data-fc-digit]'),
        hours: this.querySelector('[data-fc-unit="hours"] [data-fc-digit]'),
        minutes: this.querySelector('[data-fc-unit="minutes"] [data-fc-digit]'),
        seconds: this.querySelector('[data-fc-unit="seconds"] [data-fc-digit]'),
      };
      this._last = { days: null, hours: null, minutes: null, seconds: null };

      // Hold the calming loading shimmer for a brief moment before the
      // numbers settle in — feels gentler than an instant snap.
      this._loadingTimeout = window.setTimeout(() => {
        this.setAttribute("data-loading", "false");
        this._tick();
        this._interval = window.setInterval(this._tick, 1000);
      }, 900);
    }

    disconnectedCallback() {
      if (this._interval) window.clearInterval(this._interval);
      if (this._loadingTimeout) window.clearTimeout(this._loadingTimeout);
    }

    _computeTarget() {
      const year = parseInt(this.dataset.year, 10);
      const month = parseInt(this.dataset.month, 10);
      const day = parseInt(this.dataset.day, 10);
      const hour = parseInt(this.dataset.hour, 10) || 0;
      const minute = parseInt(this.dataset.minute, 10) || 0;
      const second = parseInt(this.dataset.second, 10) || 0;
      const tz = this.dataset.timezone || "+0000"; // e.g. "+0200"

      const iso =
        year +
        "-" + pad(month) +
        "-" + pad(day) +
        "T" + pad(hour) + ":" + pad(minute) + ":" + pad(second) +
        tz.slice(0, 3) + ":" + tz.slice(3);

      const t = new Date(iso).getTime();
      return isNaN(t) ? 0 : t;
    }

    _tick() {
      const distance = this._target - Date.now();

      if (distance <= 0) {
        this._setDigits(0, 0, 0, 0);
        this.setAttribute("data-ended", "true");
        if (this._interval) window.clearInterval(this._interval);
        return;
      }

      const days    = Math.floor(distance / 86400000);
      const hours   = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      this._setDigits(days, hours, minutes, seconds);
    }

    _setDigits(d, h, m, s) {
      this._writeDigit("days", d);
      this._writeDigit("hours", h);
      this._writeDigit("minutes", m);
      this._writeDigit("seconds", s);
    }

    _writeDigit(unit, value) {
      const el = this._units[unit];
      if (!el) return;
      if (this._last[unit] === value) return;

      const text = pad(value);

      if (this._last[unit] !== null) {
        el.classList.remove("is-flipping");
        // restart the animation
        // eslint-disable-next-line no-unused-expressions
        void el.offsetWidth;
        el.classList.add("is-flipping");
      }

      el.textContent = text;
      this._last[unit] = value;
    }
  }

  customElements.define("feminine-countdown", FeminineCountdown);
})();
